const eur = (n) => `€${Number(n || 0).toFixed(2)}`;
const DEST = [["stripe", "card"], ["wallet", "wallet"], ["voucher", "voucher"]];

export default function RefundAmountCell({ t, testid }) {
  const paid = Number(t.amount_paid || 0);
  const refundable = ["cancelled", "refunded"].includes(t.status);
  if (!refundable || t.refund_amount == null) return <span className="font-semibold">{eur(paid)}</span>;
  const refunded = Number(t.refund_amount || 0);
  const pct = paid > 0 ? Math.round((refunded / paid) * 100) : 0;
  const br = t.refund_breakdown || {};
  const dests = DEST.filter(([k]) => Number(br[k] || 0) > 0).map(([k, label]) => `${eur(br[k])} ${label}`);
  return (
    <div className="text-right leading-tight" data-testid={testid}>
      <p className="text-xs text-slate-400 line-through">{eur(paid)}</p>
      <p className="text-xs font-semibold text-red-600" data-testid={`${testid}-refunded`}>−{eur(refunded)} ({pct}%)</p>
      {dests.length > 0 && <p className="text-[10px] text-red-500">to {dests.join(" + ")}</p>}
      {Number(t.pending_stripe_amount || 0) > 0 && <p className="text-[10px] text-amber-600">{eur(t.pending_stripe_amount)} card refund pending</p>}
      <p className="font-semibold text-[#1e3a5f]" data-testid={`${testid}-kept`}>{eur(Math.max(0, paid - refunded))} kept</p>
    </div>
  );
}
